'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var radioFormContent = require('./radio-form-content-76c1bcd0.js');
var addCardButton = require('./add-card-button-75bed023.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n"], ["\n  padding: ", ";\n  display: flex;\n  flex-direction: column;\n"])), function (_a) {
    var isSwipeModalContent = _a.isSwipeModalContent;
    return (isSwipeModalContent ? 0 : '0 16px');
});
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 500 16px/24px ", ";\n  margin-bottom: 9px;\n  color: ", ";\n"], ["\n  font: 500 16px/24px ", ";\n  margin-bottom: 9px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var templateObject_1, templateObject_2;

var PaymentMethodsManager = function (_a) {
    var options = _a.options, onOptionClick = _a.onOptionClick, labels = _a.labels, paymentMethods = _a.paymentMethods, selectedPaymentMethodId = _a.selectedPaymentMethodId, onRemovePaymentMethod = _a.onRemovePaymentMethod, onAddNewCard = _a.onAddNewCard, _b = _a.isSwipeModalContent, isSwipeModalContent = _b === void 0 ? false : _b, className = _a.className, isRadioFormDisabled = _a.isRadioFormDisabled, isAddCardButtonDisabled = _a.isAddCardButtonDisabled;
    var addCardButtonText = labels.addCardButtonText, invoiceText = labels.invoiceText, formTitle = labels.formTitle, title = labels.title;
    return (React__default.createElement(Container, { "data-testid": "edit-payment", isSwipeModalContent: isSwipeModalContent, className: className },
        title && (React__default.createElement(Title, { "data-testid": "edit-payment-title" }, title)),
        React__default.createElement(radioFormContent.RadioFormContent, { invoiceText: invoiceText, paymentMethods: paymentMethods, options: options, title: formTitle, onPress: onOptionClick, selectedPaymentMethodId: selectedPaymentMethodId, onRemovePaymentMethod: onRemovePaymentMethod, disabled: isRadioFormDisabled }),
        React__default.createElement(addCardButton.AddCardButton, { isDisabled: isAddCardButtonDisabled, addCardButtonText: addCardButtonText, paymentMethods: paymentMethods, onAddNewCard: onAddNewCard })));
};

exports.PaymentMethodsManager = PaymentMethodsManager;
